export function header() {

    const path = location.pathname;

    // =====================================================================
    // ハンバーガーメニュー表示の処理
    // =====================================================================
    // document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.j-header');
    const headerModal = document.querySelector('.j-headerModal');
    const headerBtns = document.querySelectorAll('.j-header_btn');
    const svgOpen = document.querySelector('.c-open-button-line-animation');
    const svgClose = document.querySelector('.c-close-button-line-animation');

    // Lenis 停止中でも特定要素はスクロール可能に
    const menuWrap = document.querySelector('.l-header_openmenu_wrap');

    menuWrap.addEventListener('wheel', e => e.stopPropagation());
    menuWrap.addEventListener('touchmove', e => e.stopPropagation());

    headerBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const isOpen = header.classList.contains('is-open');

            header.classList.toggle('is-open', !isOpen);
            headerModal.classList.toggle('is-modalOpen', !isOpen);
            btn.classList.toggle('is-modalOpen', !isOpen);
            svgOpen?.classList.toggle('is-modalOpen', !isOpen);
            svgClose?.classList.toggle('is-modalOpen', !isOpen);

            document.body.classList.toggle('is-fixed', !isOpen);

            if (!isOpen) {
                window.lenis.stop();
                window.lenis.els.forEach(el => el.style.pointerEvents = 'auto');
            } else {
                window.lenis.start({ wheel: false });
            }
        });
    });

}